// Eskom PARCC — which bulk-update columns are REVIEW / work-product state (R6).
//
// The bulk-update whitelist is deliberately as wide as the manual editors (TK's
// call on Lindiwe's "the same mechanism as a reviewer manually updating a
// transaction"). These are the columns that carry a reviewer's OUTPUT rather
// than the population's source data — the class the 1 Jul 2026 incident taught
// us to treat carefully. They are not blocked; they are FLAGGED, so the preview
// can mark them and an operator confirming 300 rows can see at a glance that a
// spreadsheet is about to move review state.
//
// Its own module so both the matcher and the page import it without either
// depending on the other.
import type { BulkUpdateColumn } from '../../lib/importColumns';

export const REVIEW_COLUMNS: readonly BulkUpdateColumn[] = [
  'complianceLevel',
  'complianceLevelOverride',
  'reviewStatus',
  'reviewed',
  'gapsStatus',
  'findingText',
  'initialFindings',
  'updatedFindings',
];

const REVIEW_SET: ReadonlySet<string> = new Set(REVIEW_COLUMNS);

/** True when this column carries review/work-product state rather than population data. */
export function isReviewColumn(column: BulkUpdateColumn): boolean {
  return REVIEW_SET.has(column);
}
